module.exports = __webpack_public_path__ + "img/kuaiji_zizhi.1ef57503.jpg";